// @flow
import React, { useEffect } from 'react'
import { isIOS } from 'react-device-detect'
import { FormattedMessage } from 'react-intl/dist/react-intl'

import { useGlobalState } from '../store'

import makeStyles from '@material-ui/styles/makeStyles/makeStyles'

import AppleStore from '../assets/images/apple_store.png'
import GoogleStore from '../assets/images/google_store.png'

import Footer from './Footer'
import HelpBlock from './HelpBlock'
import Logo from './Logo'
import TrustBox from './TrustBox'

const useStyles = makeStyles({
  container: {
    padding: 32,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-evenly',
  },
  title: {
    fontSize: 26,
    fontWeight: 600,
    textAlign: 'center',
  },
})

const PageMobile = () => {
  const [theme] = useGlobalState('theme')
  const classes = useStyles({ theme })

  useEffect(() => {
    document.getElementById('spot-form').innerHTML = ''
    // eslint-disable-next-line
    hbspt.forms.create({
      region: 'na1',
      portalId: '5349286',
      formId: 'fb6254f8-995b-47a2-b16f-4c8324ff8222',
      target: '#spot-form',
    })
  }, [])

  return (
    <div>
      <div className={classes.container}>
        <Logo />
        <br />
        <br />
        <div className={classes.title}>
          <FormattedMessage
            id={'PageMobile.WhatIsYourNeed'}
            defaultMessage={'De quoi avez vous <c>besoin</c> ?'}
            values={{
              c: (...chunks) => <span style={{ color: theme.colors.highlightText }}>{chunks}</span>,
            }}
          />
        </div>
        <div style={{ textAlign: 'center', marginTop: 4 }}>
          <FormattedMessage
            id={'PageMobile.WeHelpYou'}
            defaultMessage={'Notre équipe va vous guider après avoir reçu votre demande.'}
          />
        </div>
        <br />
        <br />
        <div id={'spot-form'} />

        <br />
        <br />
        <TrustBox />
        <br />
        <br />
        <div>
          <FormattedMessage id={'PageMobile.Or'} defaultMessage={'Ou'} />
        </div>
        <br />
        <div>
          <FormattedMessage
            id={'PageMobile.Download3'}
            defaultMessage={
              'téléchargez notre application mobile pour rechercher un avocat en quelques minutes'
            }
          />
        </div>
        <br />
        <br />
        <img
          src={isIOS ? AppleStore : GoogleStore}
          alt={'Logo'}
          style={{ width: '50vw' }}
          onClick={() => window.open(isIOS ? theme.linkApp.ios : theme.linkApp.android)}
        />

        <br />
        <br />
      </div>

      <HelpBlock />

      <Footer />
    </div>
  )
}

export default PageMobile
